// extracted by mini-css-extract-plugin
export var logo = "_9x-2";
export var logoWrapper = "_9x-1";
export var strip = "_9x-0";